import { render, staticRenderFns } from "./OtherServiceTypeSelect.vue?vue&type=template&id=47764fec&"
import script from "./OtherServiceTypeSelect.vue?vue&type=script&lang=js&"
export * from "./OtherServiceTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports